// extracted by mini-css-extract-plugin
module.exports = {"products":"_2hrHGR","product":"u0eUlx"};